import { supertypeClass, property } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { MedicalCondition } from './MedicalCondition';
import {
  QualitativeResult,
  TestType,
  MeasureUnit,
  ResultsFindings,
  TreatmentType,
  Recommendation,
  VisitReason,
  TimePeriod,
} from '@hit/hit-api-client';
import { Customer } from './Customer';
import { RiskFactors } from './RiskFactors';
import { DiagnosisShort } from './DiagnosisShort';

@supertypeClass({ toClient: true, toServer: true })
export class MedicalPrevention extends Everything {
  @property({ getType: () => Customer })
  customer: Customer;

  @property({ getType: () => RiskFactors })
  riskFactors: RiskFactors;

  @property({ getType: () => MedicalCondition })
  medicalCondition: MedicalCondition;

  @property()
  testType: TestType;

  @property()
  optionSelected: boolean;

  @property()
  testDate: Date;

  @property()
  recommendation: Recommendation;

  @property()
  resultsType: QualitativeResult;

  @property()
  resultsFindings?: ResultsFindings;

  @property()
  resultsDesc: string;

  @property({ rule: ['numeric'] })
  testResultValue: number;

  @property()
  testResultUnitOfMeasure: string;

  @property()
  nextTestDate: Date;

  @property()
  timePeriod: TimePeriod;

  @property()
  followupInd: boolean;

  @property()
  visitReason: VisitReason;

  @property()
  details: DiagnosisShort;

  constructor() {
    super();
  }

  static new(
    riskFactors: RiskFactors,
    medicalCondition: MedicalCondition,
    optionSelected: boolean,
    testType: TestType,
    date?: Date,
    resultsFindings?: ResultsFindings,
    resultsType?: QualitativeResult
  ) {
    return new MedicalPrevention().init(
      riskFactors,
      medicalCondition,
      optionSelected,
      testType,
      date,
      resultsFindings,
      resultsType
    );
  }

  init(
    riskFactors: RiskFactors,
    medicalCondition: MedicalCondition,
    optionSelected: boolean,
    testType: TestType,
    date?: Date,
    resultsFindings?: ResultsFindings,
    resultsType?: QualitativeResult
  ) {
    this.medicalCondition = medicalCondition;
    this.riskFactors = riskFactors;
    this.customer = riskFactors.customer;
    this.testType = testType;
    this.optionSelected = optionSelected;
    this.testDate = date ? date : this.testDate;
    this.resultsFindings = resultsFindings ? resultsFindings : this.resultsFindings;
    this.resultsType = resultsType ? resultsType : this.resultsType;

    return this;
  }

  testResultValueTrigger() {
    if (this.testResultValue >= 0 && this.testResultUnitOfMeasure !== MeasureUnit.MM_MEASUNIT_WHOLE) {
      this.testResultUnitOfMeasure = MeasureUnit.MM_MEASUNIT_WHOLE;
    }
  }
  set excisionPerformed(excision: boolean) {
    this.resultsDesc = excision ? TreatmentType.OLI_TREATTYPE_EXCISION : TreatmentType.MM_TREATTYPE_NONE;
  }
  get excisionPerformed(): boolean {
    if (this.resultsDesc === TreatmentType.OLI_TREATTYPE_EXCISION) {
      return true;
    } else if (this.resultsDesc === TreatmentType.MM_TREATTYPE_NONE) {
      return false;
    }

    return undefined;
  }
}
